<template>
  <div
    class="map-container"
    :style="{
      '--source-color-dark': `var(--${color}-dark)`,
      '--source-color-main': `var(--${color}-main)`,
    }"
  >
    <div id="map" ref="map"></div>
    <Top5
      v-if="$tvaMq !== 'mobile' && $tvaMq !== 'tablet'"
      class="map-container__top"
    />
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import { mapActions, mapGetters } from "vuex";
import Top5 from "./Top5.vue";
export default {
  components: {
    Top5: Top5,
  },
  data() {
    return {
      accessToken: process.env.VUE_APP_MAPBOX_KEY,
      map: null,
      hoverID: null,
      mapConfig: null,
      mapData: null,
      popup: null,
      animationTimer: null,
      gridImg: {
        sourceID: "grid_sourceID",
        layerID: "grid_layerID",
        url: "images/griglia.png",
      },
      wavesImg: {
        sourceID: "waves_sourceID",
        layerID: "waves_layerID",
        url: "images/onde.png",
      },
    };
  },
  // props: {
  //   mapStyle: {
  //     type: String,
  //     required: true,
  //   },
  // },
  created() {
    this.map = null;
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.map) {
        this.setMapConfigByGeoArea();
        // create map
        this.initMap();

        this.setMapData();
        this.map.on("load", () => {
          // this.map.scrollZoom.disable();
          this.addDataLayer();
          this.setMapPopup();
          this.setMapEvents();
        });
      }
    });
  },
  methods: {
    initMap() {
      this.map = new mapboxgl.Map({
        accessToken: this.accessToken,
        container: this.$refs.map,
        style: this.mapStyle,
        center: this.mapConfig.center,
        zoom: this.setZoomViewportRelated(this.mapConfig.zoom),
        interactive: true,
        maxZoom: 5,
        minZoom: this.$tvaMq === "mobile" || this.$tvaMq === "tablet" ? 0 : 1,
      });
      // https://docs.mapbox.com/mapbox-gl-js/example/attribution-position/ -->[TODO] this is not working: ugly done by css
      //  this.map.addControl(new mapboxgl.AttributionControl(), 'top-left');

      const nav = new mapboxgl.NavigationControl({
        visualizePitch: false,
        showCompass: false,
      });
      this.map.addControl(nav, "bottom-right");
      if (this.$tvaMq === "mobile" || this.$tvaMq === "tablet")
        this.map.scrollZoom.disable();
    },
    setMapData() {
      let featuresArray = [];
      this.top5.forEach((item) => {
        // if coords are found, add to features array
        if (item.GEO.geometry.coordinates) {
          featuresArray.push(item.GEO);
        }
        // else {
        //   console.log("No coordinates found for", item.COUNTRY);
        // }
      });
      this.mapData = {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: featuresArray,
        },
      };
    },
    setMapEvents() {
      this.map.on("mouseenter", "outerCircle", (e) => {
        // Change the cursor style as a UI indicator.
        this.map.getCanvas().style.cursor = "";
        const hoverItem = e.features[0];
        this.onCircleHover(hoverItem);
      });
      this.map.on("click", "outerCircle", (e) => {
        this.map.getCanvas().style.cursor = "";
        this.onCircleLeave();
        const hoverItem = e.features[0];
        this.onCircleHover(hoverItem);
      });
      this.map.on("mouseleave", "outerCircle", () => {
        this.map.getCanvas().style.cursor = "";
        this.onCircleLeave();
      });
      this.map.on("styledata", () => {
        this.addDataLayer();
      });
      // const that = this;
      this.map.on("moveend", () => {
        this.updateImageCoords(this.gridImg);
        //[NB] Bagni design --> show waves only on world map
        if (this.geoArea === "World") {
          this.updateImageCoords(this.wavesImg);
        }
      });
      this.map.on("movestart", () => {
        // hide image while mooving around on the map
        this.toggleImage(this.gridImg, false);
        this.toggleImage(this.wavesImg, false);
      });
      // // // DEBUG METHODS TO FIND AREAS ON THE MAP
      // this.map.on("zoomend", () => {
      //   console.log("A zoomend event occurred.", this.map.getZoom());
      // });
      // this.map.on("dragend", () => {
      //   console.log("A MOVE event occurred.", this.map.getCenter());
      // });
    },
    setMapConfigByGeoArea() {
      this.mapConfig = this.geoAreas.find(
        (x) => x.key === this.geoArea
      ).mapConfig;
    },
    setMapPopup() {
      // Create a popup, but don't add it to the map yet.
      this.popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
        anchor: "bottom-left",
      });
    },
    updatePopup(hoverItem) {
      const html = this.getPopupHtml(hoverItem);
      const coordinates = hoverItem.geometry.coordinates.slice();
      this.popup.setLngLat(coordinates).setHTML(html).addTo(this.map);
    },
    getPopupHtml(hoverItem) {
      const value =
        hoverItem.properties.QTY.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }) +
        " " +
        this.uomByDataType;
      const country = hoverItem.properties.country;
      return `<span class='value'>${value}</span> </br> <span class='country'>${country}</span>`;
    },
    addDataLayer() {
      if (this.map && !this.map.getSource("circleData")) {
        // add data source to hold our data we want to display
        this.map.addSource("circleData", this.mapData);
        // add a layer that displays the data
        this.addCirclesToMap();
        // https://docs.mapbox.com/mapbox-gl-js/style-spec/layers/#paint-background-background-pattern
        // tried to make color transition smooth but this need some update in layerConfig
        // const that = this;
        // setTimeout(function () {
        //   that.map.setPaintProperty("outerCircle", "circle-color", {
        //     duration: 2000,
        //     delay: 0,
        //   });
        // }, 10);
      }
      this.addImageToMap(this.gridImg);
      this.addImageToMap(this.wavesImg);
    },
    addCirclesToMap() {
      // can't store config on colors in variable. mapbox doesn't like it :(
      // https://github.com/mapbox/mapbox-gl-js/issues/3170  transition are not working on data driven properties :(
      this.map.addLayer({
        id: "outerCircle",
        type: "circle",
        source: "circleData",
        paint: {
          "circle-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            0.3,
            ["boolean", ["feature-state", "inactive"], false],
            0.2,
            0.25, // default items
          ],
          "circle-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            "rgba(255, 255, 255, 0.5)",
            ["boolean", ["feature-state", "inactive"], false],
            "rgba(255, 255, 255, 0.1)",
            "rgba(255, 255, 255, 0.3)", // default items
          ],
          "circle-radius": ["get", "RADIUS_CURRENT"],
          "circle-stroke-width": 1,
          "circle-stroke-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            "rgba(255\t,211,\t0, 1)",
            ["boolean", ["feature-state", "inactive"], false],
            "rgba(255\t,211,\t0, 0.3)",
            "rgba(255\t,211,\t0, 1)", // default items
          ],
          // apparently transitions are not working on data driven properties but i found  workaround in doAnimation()
          // https://github.com/mapbox/mapbox-gl-js/issues/3170
          // "circle-radius-transition": {
          //   duration: 2000,
          //   delay: 0,
          // },
        },
      });
      this.map.addLayer({
        id: "innerCircle",
        type: "circle",
        source: "circleData",
        paint: {
          "circle-color": "#ffd300",
          "circle-radius": 3,
          "circle-stroke-width": 0,
          "circle-stroke-color": "#ffd300",
        },
      });
    },
    updateCircles(isHovered) {
      //if isHovered === TRUE --> mouse enter--> all feature to inactive , current hoverId to active
      //if isHovered === FALSE --> mouse leave-->remove  inactive from all feature  , remove hover from current hoverId
      this.mapData.data.features.forEach((f) => {
        this.map.setFeatureState(
          { source: "circleData", id: f.id },
          { inactive: isHovered }
        );
      });
      this.map.setFeatureState(
        { source: "circleData", id: this.hoverID },
        { hover: isHovered }
      );
    },
    onCircleHover(hoverItem) {
      this.map.getCanvas().style.cursor = "default";
      this.hoverID = hoverItem.id;
      this.updateCircles(true);
      this.updatePopup(hoverItem);
      // update store for top5 component
      this.setSelctedCountry();
    },
    onCircleLeave() {
      this.updateCircles(false);
      this.popup.remove();
      // update store for top5 component
      this.hoverID = null;
      this.setSelctedCountry();
    },
    doCircleAnimation() {
      const that = this;
      const MAX_COUNTER = 100;
      const INTERVAL = 10;
      const R_DELTA = 1;
      let counter = 0;
      // RADIUS_TARGET: is the final radius of the circle
      // RADIUS_CURRENT: is the current radius of the circle (mapped on circle radius property)
      // MAX_COUNTER: how many times we increase the radius
      this.animationTimer = setInterval(() => {
        // console.log("start animation interval");
        that.mapData.data.features.forEach((f) => {
          // increase current radius until it reaches the target
          if (f.properties.RADIUS_CURRENT < f.properties.RADIUS_TARGET) {
            f.properties.RADIUS_CURRENT = f.properties.RADIUS_CURRENT + R_DELTA;
          }
        });
        if (that.map.getSource("circleData")) {
          // console.log("UPDATING SOURCE");
          that.map.getSource("circleData").setData(that.mapData.data);
        }
        counter++;
        if (counter > MAX_COUNTER) {
          // console.log("clear animation interval");
          clearInterval(that.animationTimer);
        }
      }, INTERVAL);
    },
    addImageToMap(imgConfig) {
      // https://docs.mapbox.com/mapbox-gl-js/example/image-on-a-map/
      if (!this.map.getSource(imgConfig.sourceID)) {
        const coords = this.getImageCoords();
        this.map.addSource(imgConfig.sourceID, {
          type: "image",
          url: this.$baseUrl + imgConfig.url,
          coordinates: coords,
        });
        this.map.addLayer({
          id: imgConfig.layerID,
          type: "raster",
          source: imgConfig.sourceID,
          paint: {
            "raster-fade-duration": 0,
          },
        });
      }
    },
    getImageCoords() {
      const bound = this.map.getBounds().toArray();
      const c0 = [bound[0][0], bound[0][1]];
      const c1 = [bound[1][0], bound[0][1]];
      const c2 = [bound[1][0], bound[1][1]];
      const c3 = [bound[0][0], bound[1][1]];
      return [c0, c1, c2, c3];
    },
    updateImageCoords(imgConfig) {
      const source = this.map.getSource(imgConfig.sourceID);
      if (source) {
        const coords = this.getImageCoords();
        source.setCoordinates(coords);
        this.toggleImage(imgConfig, true);
      }
    },
    toggleImage(imgConfig, value) {
      const opacity = value ? 1 : 0;
      this.map.setPaintProperty(imgConfig.layerID, "raster-opacity", opacity);
    },
    setSelctedCountry() {
      this.setSelectedCountryId(this.hoverID);
    },
    setZoomViewportRelated(config) {
      let value = 1500;
      let increment = (window.innerWidth - value) / value;
      return increment + config;
    },
    ...mapActions({
      setSelectedCountryId: "ui/setSelectedCountryId",
    }),
  },
  computed: {
    color() {
      return this._color();
    },
    uomByDataType() {
      let res = "";
      if (this.uom) {
        let r = this.uom.find((x) => x.dataType === this.dataType);
        if (r) {
          // this condition is needed to avoid error when dataType is still changing when switching from one source to another
          res = `${r.uom}`;
        }
      }
      return res;
    },
    ...mapGetters({
      top5: "data/getTop5",
      uom: "ui/uom",
      _color: "ui/sourceColor",
      dataType: "ui/dataType",
      geoArea: "ui/geoArea",
      geoAreas: "ui/geoAreas",
      selectedCountryId: "ui/selectedCountryId",
      mapStyle: "ui/mapStyle",
    }),
  },
  watch: {
    geoArea() {
      if (this.map) {
        // console.log("GEOAREA");
        this.setMapConfigByGeoArea();
        this.map.flyTo({
          center: this.mapConfig.center,
          zoom: this.setZoomViewportRelated(this.mapConfig.zoom),
          speed: 1,
          curve: 1,
          easing(t) {
            return t;
          },
        });
      }
    },
    async top5() {
      if (this.map) {
        // console.log("WATCH NEW DATA");
        this.setMapData();
        if (this.map && this.mapData && this.map.getSource("circleData")) {
          this.map.getSource("circleData").setData(this.mapData.data);
        }
        /* https://github.com/mapbox/mapbox-gl-js/issues/3170
            since transition does not work on data driven properties, i am using a hack to make circle increase size over time
            if this is not working, just comment this block and everything shuld work fine :)*/
        // wait a while before starting animation
        await new Promise((resolve) => setTimeout(resolve, 100));
        this.doCircleAnimation();
      }
    },
    selectedCountryId(newVal) {
      if (newVal !== null) {
        const hoverItem = this.mapData.data.features.find(
          (x) => x.id === newVal
        );
        this.onCircleHover(hoverItem);
      } else {
        this.onCircleLeave();
      }
    },
    mapStyle(newVal) {
      // console.log("WATCH MAP STYLE");
      if (this.map) {
        this.map.setStyle(newVal);
        this.addDataLayer();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .mapbox-improve-map {
  display: none;
}
::v-deep .mapboxgl-control-container {
  .mapboxgl-ctrl-bottom-left {
    height: fit-content;
    width: 75%;
    .mapboxgl-ctrl {
      float: right;
      margin: 0;
      opacity: 0;

      .mapboxgl-ctrl-logo {
        width: 40px;
        height: 15px;
      }
    }
  }
  .mapboxgl-ctrl-bottom-right {
    // position: relative;
    right: 20%;

    .mapboxgl-ctrl-attrib {
      background-color: rgba(255, 255, 255, 0.1);
      height: toRem(25);
      display: flex;
      align-items: flex-start;

      * {
        color: var(--gray_03);
      }
    }
    .mapboxgl-ctrl-group {
      background: transparent;
      box-shadow: none;
      border-radius: 0;
    }
    .mapboxgl-ctrl-zoom-in,
    .mapboxgl-ctrl-zoom-out {
      background: transparent;
      border: solid 1px rgba(255, 255, 255, 0.2);
      &:hover {
        background-color: rgba(255, 255, 255, 0.05);
      }
    }
    .mapboxgl-ctrl-zoom-in {
      border-bottom: none;
      background-image: url("data:image/svg+xml;utf8,<svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'><g opacity='0.8'><path fill-rule='evenodd' clip-rule='evenodd' d='M7.80976 4.01758C8.04045 4.01758 8.22747 4.20459 8.22747 4.43529V8.36177H12.154C12.3846 8.36177 12.5717 8.54879 12.5717 8.77948C12.5717 9.01018 12.3846 9.19719 12.154 9.19719H8.22747V13.1237C8.22747 13.3544 8.04045 13.5414 7.80976 13.5414C7.57906 13.5414 7.39205 13.3544 7.39205 13.1237V9.19719H3.46556C3.23487 9.19719 3.04785 9.01018 3.04785 8.77948C3.04785 8.54879 3.23487 8.36177 3.46556 8.36177H7.39205V4.43529C7.39205 4.20459 7.57906 4.01758 7.80976 4.01758Z' fill='white'/></g></svg>");
      background-repeat: no-repeat;
      background-position: 50%;
    }
    .mapboxgl-ctrl-zoom-out {
      background-image: url("data:image/svg+xml;utf8,<svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'><g opacity='0.8'><path d='M8.22747 8.52148H12.154C12.3846 8.52148 12.5717 8.7085 12.5717 8.9392C12.5717 9.16989 12.3846 9.35691 12.154 9.35691H8.22747L7.39205 9.35691H3.46556C3.23487 9.35691 3.04785 9.16989 3.04785 8.9392C3.04785 8.7085 3.23487 8.52148 3.46556 8.52148H7.39205H8.22747Z' fill='white'/></g></svg>");
      background-repeat: no-repeat;
      background-position: 50%;
    }
  }
}
// @keyframes popup {
//   0% {
//     visibility: hidden;
//     opacity: 0;
//     transform: translate(-40px, 50px);
//   }
//   100% {
//     visibility: visible;
//     opacity: 1;
//     transform: translate(10px, 50px);
//   }
// }
.map-container {
  position: relative;
  height: 100%;

  &__top {
    position: absolute;
    top: 0;
    right: 0;
  }
}

#map {
  width: 100%;
  height: 100%;
}

.mapboxgl-canvas {
  cursor: auto !important;
}

::v-deep .mapboxgl-popup-content {
  background-color: var(--source-color-dark);
  min-width: 100px;
  margin-bottom: 20px;
}
::v-deep .mapboxgl-popup-content {
  transform: translate(10px, 50px);
  animation-name: popup;
  animation-duration: 0.5s;
  pointer-events: none;
  padding: toRem(5) toRem(10);

  .value {
    @include number-S;
    color: $primary-yellow;
  }
  .country {
    @include dida-S;
    color: $ui-white;
  }
}

::v-deep .mapboxgl-popup-tip {
  display: none;
}

::v-deep .mobile {
  .mapboxgl-map {
    .mapboxgl-control-container {
      .mapboxgl-ctrl-bottom-right {
        right: 0;
      }
    }
  }
}

.map-container {
  .tablet &,
  .mobile & {
    height: 45.3vh;
    ::v-deep .mapboxgl-control-container {
      .mapboxgl-ctrl-bottom-right {
        right: 0;
      }
    }
  }
}

.tablet {
  .map-container {
    height: 37.1vh;
  }
}

// ::v-deep .mapboxgl-ctrl-bottom-left {
//   top: 45px;
//   right: 0;
//   left: 90%;

//   // .mapboxgl-ctrl-logo{
//   //   width: 50px;
//   // }
// }
</style>
